import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M15 14.3a3.5 3.5 0 1 1-7 0C8 11.5 11.5 8 11.5 8s3.5 3.5 3.5 6.3z"></path><path fill-rule="evenodd" d="M19 4v14h2c.825 0 1.567.402 2.082.918.515.515.918 1.257.918 2.082v4c0 .351.09.596.206.735.089.107.285.265.794.265.51 0 .705-.158.794-.265.116-.14.206-.384.206-.735v-8h-1a1 1 0 0 1-1-1v-3a3 3 0 0 1 3-3h.5l.43-2.582A.5.5 0 0 1 28.425 7h.486a.5.5 0 0 1 .493.582L29.001 10h.423a.5.5 0 0 1 .495.57l-.796 5.571a1 1 0 0 1-.99.859H28v8c0 .649-.16 1.404-.67 2.015-.535.643-1.34.985-2.33.985s-1.795-.342-2.33-.985C22.16 26.405 22 25.65 22 25v-4c0-.175-.098-.433-.332-.668-.235-.235-.493-.332-.668-.332h-2v3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1V4a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1zM5 27v-2h1V5h11v13h-1a1 1 0 1 0 0 2h1v5h1v2H5zm22.903-14.418A.5.5 0 0 0 27.41 12H27a1 1 0 0 0-1 1v1.5a.5.5 0 0 0 .5.5h.577a.5.5 0 0 0 .493-.418l.333-2z" clip-rule="evenodd"></path></g>';
export var GasStationOutlineSVG = function GasStationOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
GasStationOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GasStationOutlineSVG);